import moment from 'moment';
export const formatYYYYMMDDValue = (value) => {
    return moment(value).format();
};
//# sourceMappingURL=formatYYYYMMDDValue.js.map